import { FormProps, AppFormTabProps } from 'components/AppFormLayout/AppFormData'

export const EntityFormData = [
	{
		tabId: 0,
		title: '表字段',
		isHidden: false,
		appFormBlockList: [
			{
				colNumber: 1,
				title: '',
				labelWidth: 120,
				appFormItemList: [
					{
						type: 'Input',
						dataType: 'string',
						field: 'displayName',
						label: '中文名称',
                        placeholder:"请输入中文名称",
                        req: true
					},
					{
						type: 'Input',
						dataType: 'string',
						field: 'name',
                        label: '英文名称',
                        placeholder:"请输入英文名称",
						req: true,
                    },
                    {
						type: 'Input',
						dataType: 'string',
						field: 'primaryKey',
                        label: '主键字段',
						placeholder:"请输入主键字段",
						req: true,
                    }
				],
			},
		],
	},
] as any[]



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/EntityFormData.tsx